import { render, staticRenderFns } from "./SettingControl.vue?vue&type=template&id=ac2e5756&scoped=true"
import script from "./SettingControl.vue?vue&type=script&lang=js"
export * from "./SettingControl.vue?vue&type=script&lang=js"
import style0 from "./SettingControl.vue?vue&type=style&index=0&id=ac2e5756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2e5756",
  null
  
)

export default component.exports